// extracted by mini-css-extract-plugin
export default {"priceSlider":"PriceSlider_priceSlider__23MQK","label":"PriceSlider_label__51WfX","slider":"PriceSlider_slider__uvQ28"};